import "./App.css";
import React, { Suspense, useState } from "react";
import { BrowserRouter } from "react-router-dom";

//assets
import logo from "../assets/img/logo.svg";

//routers
import { AppRouter } from "./routers/AppRouter";

//layouts
import { MobileContainer } from "../shared/layouts/MobileContainer";

//Data Display
import { LoadingAlert } from "../shared/data_display/LoadingAlert";

export default function App() {
  document.title = "Cian-MQ";
  const [loaded, setLoaded] = useState(false);

  return (
    <>
      {loaded === false && <LoadingAlert />}

      <Suspense fallback={<LoadingAlert />}>
        <BrowserRouter>
          <MobileContainer>
            <AppRouter
              onStartLoadingPage={() => {
                console.log("----StartLoading");
                setLoaded(false);
              }}
              onLoad={() => {
                console.log("----Loaded");
                setLoaded(true);
              }}
            />
          </MobileContainer>
        </BrowserRouter>
      </Suspense>
    </>
  );
}

//export default App;
